import React from 'react';

import AdUnitWithRoute, { AdUnitProps } from '../google-dfp';

export const Halfpage = (props: AdUnitProps) => {
    return (
        <AdUnitWithRoute
            adUnitCode='halfpage-top' //there is also halfpage-bottom, override via props
            sizes={['fluid', [300, 300], [300, 600]]}
            {...props}
        />
    );
};

export const ZoznamHalfpageTop = (props: AdUnitProps) => {
    return (
        <AdUnitWithRoute
            overrideAdUnitCode={true}
            adUnitCode='/60012913/Mojasvadba-halfpage'
            sizes={[
                [300, 300],
                [300, 600],
                [300, 100],
                [300, 250],
            ]}
            {...props}
        />
    );
};

export const ZoznamHalfpageBottom = (props: AdUnitProps) => {
    return (
        <AdUnitWithRoute
            overrideAdUnitCode={true}
            adUnitCode='/60012913/Mojasvadba-halfpage1'
            sizes={[
                [300, 300],
                [300, 600],
                [300, 100],
                [300, 250],
            ]}
            {...props}
        />
    );
};

// TOP SIDEBAR
export const ZahradaSquare = (props: AdUnitProps) => {
    return (
        <AdUnitWithRoute
            overrideAdUnitCode
            adUnitCode='/1023789/ZAHRADA-square'
            divAdId='div-gpt-ad-1634134940333-0'
            sizes={['fluid', [300, 300], [300, 250]]}
            {...props}
        />
    );
};

// BOTTOM SIDEBAR
export const ZahradaDoubleSquare = (props: AdUnitProps) => {
    return (
        <AdUnitWithRoute
            overrideAdUnitCode
            adUnitCode='/1023789/zahrada-double-square'
            divAdId='div-gpt-ad-1634134716918-0'
            sizes={[[300, 250], 'fluid', [300, 300], [300, 600]]}
            {...props}
        />
    );
};
